// extracted by css-extract-rspack-plugin
var _1 = "src-pages-Fallbacks-NotFound-NotFound-module__buttons-ZTg5CU";
var _2 = "src-pages-Fallbacks-NotFound-NotFound-module__content-RVobUp";
var _3 = "src-pages-Fallbacks-NotFound-NotFound-module__errorPage-U7fr_V";
var _4 = "src-pages-Fallbacks-NotFound-NotFound-module__errorPageWrapper-o44gNY";
var _5 = "src-pages-Fallbacks-NotFound-NotFound-module__hand-cvC8fD";
var _6 = "src-pages-Fallbacks-NotFound-NotFound-module__text-tK744W";
var _7 = "src-pages-Fallbacks-NotFound-NotFound-module__uri-epUOnB";
export { _1 as "buttons", _2 as "content", _3 as "errorPage", _4 as "errorPageWrapper", _5 as "hand", _6 as "text", _7 as "uri" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"buttons\":\"src-pages-Fallbacks-NotFound-NotFound-module__buttons-ZTg5CU\",\"content\":\"src-pages-Fallbacks-NotFound-NotFound-module__content-RVobUp\",\"errorPage\":\"src-pages-Fallbacks-NotFound-NotFound-module__errorPage-U7fr_V\",\"errorPageWrapper\":\"src-pages-Fallbacks-NotFound-NotFound-module__errorPageWrapper-o44gNY\",\"hand\":\"src-pages-Fallbacks-NotFound-NotFound-module__hand-cvC8fD\",\"text\":\"src-pages-Fallbacks-NotFound-NotFound-module__text-tK744W\",\"uri\":\"src-pages-Fallbacks-NotFound-NotFound-module__uri-epUOnB\"}";
        // 1752373455088
        var cssReload = require("../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  